import { useDeviceHttpProxy } from '@/hooks/DeviceHttpProxy/useDeviceHttpProxy'
import { useCallback, useMemo } from 'react'
import { Logger } from '@/utils/Logger'
import {
  GET_DEVICE_SETUP_STATUS_SERVICE,
  SET_DEVICE_SETUP_ACTION_SERVICE
} from '@/constants/DeviceHttpProxy'

export function useDeviceSetup() {
  const { sendRequest } = useDeviceHttpProxy()

  const updateActionInDeviceSetup = useCallback(
    async (prop, bodyToUpdate) => {
      try {
        const { body } = await sendRequest(GET_DEVICE_SETUP_STATUS_SERVICE)

        if (prop in body.data) {
          await sendRequest(
            SET_DEVICE_SETUP_ACTION_SERVICE,
            { version: body.data.version, ...bodyToUpdate },
            undefined,
            false
          )
        }
      } catch (error) {
        Logger.error(`Error updating ${prop} in device setup:`, error)
      }
    },
    [sendRequest]
  )

  return useMemo(() => ({ updateActionInDeviceSetup }), [
    updateActionInDeviceSetup
  ])
}
